import * as turf from "@turf/turf";
import Point from "@/store/models/point";

export const coordinateEditorStore = {
  state: () => ({
    lat: undefined,
    lng: undefined,
    geojson: Point.default().toGeoJSON(),
    editingPolygon: false,
    formMap: null,
    polyEditorMap: null,
  }),

  getters: {
    coordinateMode: (state) => {
      return state.geojson.geometry.type;
    },

    center: (state, getters) => {
      // In Point mode, the center is just the point
      if (getters.coordinateMode == "Point") {
        return state.geojson;
      }

      // In Polygon mode, return the center of the centers
      if (getters.coordinateMode == "MultiPolygon") {
        return turf.center(
          turf.featureCollection(
            state.geojson.geometry.coordinates.map((path) => {
              return turf.centerOfMass(turf.polygon([path]));
            })
          )
        );
      }
    },
  },

  mutations: {
    setFormMap(state, map) {
      state.formMap = map;
    },

    setPolyEditorMap(state, map) {
      state.polyEditorMap = map;
    },

    setGeoJSON(state, geojson) {
      state.geojson = geojson;
    },

    setCoordinates(state, point) {
      [state.lng, state.lat] = turf.getCoord(point);
    },

    setLat(state, lat) {
      state.lat = lat;
      var lastDigit = Number.isInteger(lat)
        ? lat % 10
        : lat.toString().slice(-1);
      var latValue = parseFloat(state.lat);
      if (lastDigit === ".") {
        latValue = state.lat;
      }
      state.geojson = new Point(latValue, parseFloat(state.lng)).toGeoJSON();
    },

    setLng(state, lng) {
      state.lng = lng;
      var lastDigit = Number.isInteger(lng)
        ? lng % 10
        : lng.toString().slice(-1);
      var lngValue = parseFloat(state.lng);
      if (lastDigit === ".") {
        lngValue = state.lng;
      }
      state.geojson = new Point(parseFloat(state.lat), lngValue).toGeoJSON();
    },

    resetGeoJSON(state) {
      state.geojson = Point.default().toGeoJSON();
      state.lat = undefined;
      state.lng = undefined;
    },

    editingPolygon(state, value) {
      state.editingPolygon = value;
    },
  },
};
